export const environment = {
  dazerolab: {
    local: false,
    production: true,
    enableProdMode: true,
    title: "Botmaster",
    languages: { supported: ["it", "en"], default: "en" },
    graphql: {
      url: "http://localhost:4000/graphql"
    },
    statusPageLink: "https://botmaster.statuspage.io/",
    api: {
      get iam() {
        return (
          localStorage.getItem("endpoint-iam") ||
          `https://backend.staging.snoots.pet/iam`
        );
      },
      get oracle() {
        return (
          localStorage.getItem("endpoint-oracle") ||
          `https://backend.staging.snoots.pet/oracle`
        );
      }
    },
    auth: {
      cookie: {
        name: "token",
        storageDomainName: ".botmaster.ai"
      },
      cognito: {
        region: "eu-central-1",
        userPoolId: "eu-central-1_IdRbVBmSN",
        userPoolWebClientId: "2flvkggjrqh4hvame84esifubr"
      }
    },
    list: {
      pageSize: 25
    },
    http: {
      timeout: 10000000
    },
    serverEvents: {
      endpoint: "", // sse
      timeoutRetry: 5000
    },
    service_worker: {
      check_update_interval: 1000 * 60
    },
    notification: {
      duration: 5000
    },
    tinyMcApiKey: "2wp19kasugzcjuleqqthf1p4r04dnw9c1uewpp9skn9z50xl",
    tag: {
      color: "#64748b"
    },
    helpcenter: {
      urls: {
        enable_backup: ""
      }
    }
  },
  snoots: {
    local: false,
    production: true,
    enableProdMode: true,
    title: "PMS",
    languages: { supported: ["it", "en", "es", "fr", "ka"], default: "it" },
    graphql: {
      url: "http://localhost:4000/graphql"
    },
    keys: {
      adobe: {
        pms: "",
        rocket: "5ac30c7f159343bb835c816bf7fead3b"
      }
    },
    statusPageLink: "https://snoots.statuspage.io/",
    storageEndpoint: `http://${location.hostname}:12000/db/`,
    dmc4ceeEndpoint: `http://${location.hostname}:8443`,
    dicomViewer: {
      host: `http://${location.hostname}:12001`
    },
    api: {
      enigma: "https://backend.snoots.pet/enigma",
      babel: "https://babel.snoots.pet",
      analytics: `https://backend.snoots.pet/analytics`,
      diagnostic: `https://backend.snoots.pet/diagnostic`,
      iam: `https://backend.snoots.pet/iam`,
      tag: `https://backend.snoots.pet/tag`,
      directory: `https://backend.snoots.pet/directory`,
      store: "https://backend.snoots.pet/store",
      storage: "https://backend.snoots.pet/storage",
      organization: "https://backend.snoots.pet/organization",
      notification: `https://backend.snoots.pet/notification`,
      calendar: `https://backend.snoots.pet/calendar`,
      healthcare: `https://backend.snoots.pet/healthcare`,
      billing: `https://backend.snoots.pet/billing`,
      warehouse: `https://backend.snoots.pet/warehouse`,
      integrator: `https://backend.snoots.pet/integrator`
    },
    auth: {
      cookie: {
        name: "token",
        storageDomainName: "storage.snoots.pet"
      },
      cognito: {
        region: "eu-west-1",
        userPoolId: "eu-central-1_icevxgecw",
        userPoolWebClientId: "ui8v4e2fgencorsp8c3419j65"
      }
    },
    list: {
      pageSize: 25
    },
    http: {
      timeout: 10000000
    },
    broker: {
      endpoint: "https://backend.snoots.pet/broker/v1/events",
      timeoutRetry: 5000
    },
    service_worker: {
      check_update_interval: 1000 * 60
    },
    box: {
      port: "8443",
      checkInterval: 5 * 60 * 1000,
      checkEndpointFn: (ip: string, port: string) =>
        `https://${ip}:${port}/dcm4chee-arc/aets/DCM4CHEE/dimse/DCM4CHEE`,
      downloadEndpointFn: (address: string, port: string, studyId: string) =>
        `https://${address}:${port}/dcm4chee-arc/aets/DCM4CHEE/rs/studies/${studyId}?accept=application/zip`
    },
    toolkit: {
      endpoint: "https://toolkit.snoots.pet"
    },
    print: {
      endpointV3: "https://toolkit.snoots.pet/create-pdf-v3"
    },
    horos: {
      urlFn: (url: string) =>
        `horos://?methodName=DownloadURL&Display=YES&URL=${url}`
    },
    species: ["dog", "cat"],
    viewer: {
      iframeSrc: () => `https://viewer.snoots.pet/viewer`,
      urlFn: (studyUuid: string, configParam: string) =>
        `https://viewer.snoots.pet/segmentation/${studyUuid}?config=${configParam}`,
      storage: {
        wadoUriRootFn: ({
          tenantId,
          storageId
        }: {
          tenantId: string;
          storageId: string;
        }) => `https://storage.snoots.pet/${tenantId}/${storageId}`,
        qidoRootFn: ({
          tenantId,
          storageId
        }: {
          tenantId: string;
          storageId: string;
        }) => `https://storage.snoots.pet/${tenantId}/${storageId}`,
        wadoRoot: ({
          tenantId,
          storageId
        }: {
          tenantId: string;
          storageId: string;
        }) => `https://storage.snoots.pet/${tenantId}/${storageId}`
      }
    },
    notification: {
      duration: 5000
    },
    tinyMcApiKey: "2wp19kasugzcjuleqqthf1p4r04dnw9c1uewpp9skn9z50xl",
    tag: {
      color: "#64748b"
    },
    vilma: {
      host: "https://app.vilmacloud.com"
    },
    templates: {
      appointment_reminder_it: "4998487",
      appointment_reminder_en: "6220066",
      reminder_messages: "4998487"
    },
    helpcenter: {
      urls: {
        enable_backup:
          "https://helpcenter.snoots.pet/docs/rogan-documentation/backup/attivazione-e-monitoraggio/"
      }
    },
    openpanel: {
      apiUrl: "https://op.snoots.pet/api",
      clientId: "a98e2296-0364-4ae4-8b89-c1580bd56890",
      clientSecret: "sec_68d16615f0f5518e2b7c"
    }
  }
};
